import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "video-player-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "controls-overlay" }
const _hoisted_4 = { class: "play-btn-container" }
const _hoisted_5 = { class: "progress-container" }
const _hoisted_6 = { class: "video-time" }
const _hoisted_7 = { class: "progress-bar-container" }
const _hoisted_8 = { class: "video-time" }
const _hoisted_9 = { class: "video-voice-container" }
const _hoisted_10 = { class: "volume-control-inner" }
const _hoisted_11 = { class: "volume-value" }
const _hoisted_12 = { class: "volume-bar-container" }

import { ref, watch, onMounted, onUnmounted, getCurrentInstance, computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isShow: {
    type: Boolean,
    default: false
  },
  videoSrc: {
    type: String,
    default: ''
  },
  showCloseIcon: {
    type: Boolean,
    default: true
  }
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const isPlaying = ref(false)
const currentTime = ref(0)
const duration = ref(0)
const volume = ref(0.5)
const showVolumeControl = ref(false)
const volumeValue = ref(50)
const voiceIconRef = ref<HTMLDivElement>()
const volumeControlRef = ref<HTMLDivElement>()
const videoRef = ref<HTMLVideoElement>()
const currentSpeed = ref(1.0)



////////////////////////////////////////  监听器/计算属性
const voiceIcon = computed(()=>{
    if(volume.value === 0){
        return 'iconfont-line vk_sygb_line'
    }else if(volume.value > 0 && volume.value < 0.7){
        return 'iconfont-line vk_syr_line'
    }else{
        return 'iconfont-line vk_syq_line'
    }
})

watch(volumeValue, (newVal, oldVal) => {
    volume.value = newVal / 100
    if(videoRef.value){
        videoRef.value.volume = volume.value
    }
})

watch(()=>currentTime.value, (newVal, oldVal) => {
    console.log('currentTime.value----', newVal,currentSpeed.value, videoRef.value.playbackRate)
})



///////////////////////////////////////  方法
const formatTime = (time:number) => {
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const handleParentClick = (event:MouseEvent) => { 
    const target = event.target as HTMLElement;
    if((voiceIconRef.value && voiceIconRef.value.contains(target)) || (volumeControlRef.value && volumeControlRef.value.contains(target))){
        return
    }
    if(showVolumeControl.value){
        showVolumeControl.value = false
    }
}

const handleChangeSlider = (val:number) => {
    if(!isPlaying.value) return
    videoRef.value.currentTime = val
}

const handlePause = () => {
    videoRef.value?.pause()
}

const handlePlay = () => {
    videoRef.value?.play()
}

const onLoadedMetadata = () => {
    duration.value = videoRef.value?.duration || 0
    videoRef.value.volume = volume.value
    currentSpeed.value = videoRef.value?.playbackRate || 1.0
}

const onTimeUpdate = () => {
    currentTime.value = videoRef.value?.currentTime || 0
}

const onEnded = () => {
    isPlaying.value = false
}

const togglePlay = () => {
  if (videoRef.value) {
    if (isPlaying.value) {
      videoRef.value.pause()
    } else {
      videoRef.value.play()
    }
  }
}

const handleKeyPress = (event: KeyboardEvent) => {
    if (event.code === 'Space' && !event.shiftKey) {
        event.preventDefault()
        togglePlay()
    }
    if(isPlaying.value){
        //前进10秒
        if (event.code === 'ArrowRight' && !event.shiftKey) {
            event.preventDefault()
            videoRef.value.currentTime += 10
        }
        //后退10秒
        if (event.code === 'ArrowLeft' && !event.shiftKey) {
            event.preventDefault()
            videoRef.value.currentTime -= 10
        }
    }
    
}

///////////////////////////////////////// 生命周期
onMounted(()=>{
    window.addEventListener('keydown', handleKeyPress)
})

onUnmounted(()=>{
    if(videoRef.value){
        videoRef.value.pause()
    }
    videoRef.value = null
    currentTime.value = 0
    duration.value = 0
    volume.value = 0.5
    volumeValue.value = 50
    currentSpeed.value = 1.0
    window.removeEventListener('keydown', handleKeyPress)
})




return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "video-inner-box",
      onClick: handleParentClick
    }, [
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "close-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onClose')))
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "iconfont-line vk_gb_line1" }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("video", {
        class: "video-player",
        ref_key: "videoRef",
        ref: videoRef,
        src: props.videoSrc,
        autoplay: false,
        onLoadedmetadata: onLoadedMetadata,
        onTimeupdate: onTimeUpdate,
        onEnded: onEnded,
        onPlay: _cache[1] || (_cache[1] = ($event: any) => (isPlaying.value = true)),
        onPause: _cache[2] || (_cache[2] = ($event: any) => (isPlaying.value = false))
      }, null, 40, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (isPlaying.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "iconfont-line vk_zt_line1",
                onClick: handlePause
              }))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "iconfont-fill vk_jtzs_fill",
                onClick: handlePlay
              }))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(formatTime(currentTime.value)), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_slider, {
              modelValue: currentTime.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentTime).value = $event)),
              min: 0,
              max: duration.value,
              step: currentSpeed.value,
              "show-tooltip": false,
              onInput: handleChangeSlider
            }, null, 8, ["modelValue", "max", "step"])
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(formatTime(duration.value)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("i", {
            class: _normalizeClass(voiceIcon.value),
            ref_key: "voiceIconRef",
            ref: voiceIconRef,
            onClick: _cache[4] || (_cache[4] = ()=>{showVolumeControl.value = !showVolumeControl.value})
          }, null, 2)
        ])
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "volume-control-container",
        ref_key: "volumeControlRef",
        ref: volumeControlRef
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(volumeValue.value) + "%", 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_slider, {
              modelValue: volumeValue.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((volumeValue).value = $event)),
              vertical: "",
              step: 1
            }, null, 8, ["modelValue"])
          ])
        ])
      ], 512), [
        [_vShow, showVolumeControl.value]
      ])
    ])
  ]))
}
}

})